import { Component, OnInit } from '@angular/core';
import { filter, map } from 'rxjs/operators';
import { SearchService } from '../../services/search-service.service';
import { ActivatedRoute, Router, NavigationEnd, PRIMARY_OUTLET } from '@angular/router';

export interface IBreadCrumb {
  label: string;
  url: string;
}

@Component({
  selector: 'app-breadcrumb-row',
  templateUrl: './breadcrumb-row.component.html',
  styleUrls: ['./breadcrumb-row.component.scss'],
})
export class BreadcrumbRowComponent implements OnInit {
  public breadcrumbs: IBreadCrumb[] = [];
  params: any = '';
  title: any = 'Home';
  menuArr: any = {
    walksandtrails: 'Walks and Trails',
    downloads: 'Downloads',
    'food-drinks': 'Food & Drinks',
    theislands: 'The Islands',
    generalservices: 'General services',
    travelinformation: 'Travel Information',
    wheretostay: 'Where To Stay',
    touroperators: 'Tour Operators',
    gettingaround: 'Getting Around',
    airlines: 'Airlines',
    informationservices: 'Information Services',
  };
  routeMenuArr: any = {
    ACCOMM: [
      {
        label: 'Plan Your Visit',
        url: '/planyourvisit/wheretostay',
      },
      {
        label: 'Where To Stay',
        url: '/planyourvisit/wheretostay',
      },
    ],
    GETTINGAROUND: [
      {
        label: 'Plan Your Visit',
        url: '/planyourvisit/gettingaround',
      },
      {
        label: 'Getting Around',
        url: '/planyourvisit/gettingaround',
      },
    ],
    AIRLINES: [
      {
        label: 'Plan Your Visit',
        url: '/planyourvisit/airlines',
      },
      {
        label: 'Airlines',
        url: '/planyourvisit/airlines',
      },
    ],
    TOUROPERATOR: [
      {
        label: 'Plan Your Visit',
        url: '/planyourvisit/touroperators',
      },
      {
        label: 'Tour Operators',
        url: '/planyourvisit/touroperators',
      },
    ],
    TOUR: [
      {
        label: 'Experience',
        url: '/planyourvisit/activities',
      },
      {
        label: 'Activities',
        url: '/planyourvisit/activities',
      },
    ],
    GENSERVICE: [
      {
        label: 'Experience',
        url: '/experience/generalservices',
      },
      {
        label: 'General Services',
        url: '/experience/generalservices',
      },
    ],
    ATTRACTION: [
      {
        label: 'Experience',
        url: '/experience/attraction',
      },
      {
        label: 'Attraction',
        url: '/experience/attraction',
      },
    ],
    RESTAURANT: [
      {
        label: 'Experience',
        url: '/experience/food-drinks',
      },
      {
        label: 'Food & Drinks',
        url: '/experience/food-drinks',
      },
    ],
    EVENT: [
      {
        label: 'Experience',
        url: '/experience/events',
      },
      {
        label: 'Event',
        url: '/experience/events',
      },
    ],
    DESTINFO: [
      {
        label: 'Experience',
        url: '/experience/theislands',
      },
      {
        label: 'The Islands',
        url: '/experience/theislands',
      },
    ],
  };

  gettingAroundCla = [
    'BICYCLE',
    'BOAT',
    'CAR',
    'DOMAIRSVC',
    'EQUIP',
    'MINBUSCOAC',
    'YACHT',
    'BUSSVC',
    'COACHSVC',
    'FERRYSVC',
    'TAXI',
  ];
  airlineCla = ['INTAIRSVC'];

  constructor(
    private activatedRoute: ActivatedRoute,
    private searchService: SearchService,
    private router: Router,
    private routes: ActivatedRoute
  ) {
    this.routes.paramMap.subscribe((paramMap) => {
      const productId: any = paramMap.get('ProductId');
      //console.log(productId);
      if (productId && productId !== null) {
        this.searchService.getCatandCla(productId).subscribe((res: any) => {
          if (res && res.products && res.products.length > 0) {
            const data = res.products[0];
            // const breads = localStorage.getItem('bread');
            // const burl:any = localStorage.getItem('breadurl');
            // const breadcrum = JSON.parse(breads);
            // if(breadcrum) {
            //   breadcrum.forEach((item:any) => {
            //     let url = '';
            //     if(item.url == '') {
            //       url = burl;
            //     }
            //     this.breadcrumbs.push({label: item.label, url:url});
            //   });
            // }
            let category = data.productCategoryId;
            if (category == 'TRANSPORT') {
              let productClassifications = data.productClassifications;
              if (
                productClassifications.some((classification: any) => this.gettingAroundCla.includes(classification))
              ) {
                category = 'GETTINGAROUND';
              } else if (
                productClassifications.some((classification: any) => this.airlineCla.includes(classification))
              ) {
                category = 'AIRLINES';
              }
            }
            const val = this.routeMenuArr[category];
            if (val) {
              this.breadcrumbs.push(val[0]);
              this.breadcrumbs.push(val[1]);
            }
            this.breadcrumbs.push({ label: data.productName, url: '' });
          }
        });
      } else {
        this.breadCrumbData();
      }
    });
  }

  ngOnInit(): void {}

  breadCrumbData(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .pipe(filter((route) => route.outlet === PRIMARY_OUTLET))
      .subscribe((route) => {
        this.params = route.snapshot.params;
        if (route.snapshot.data.breadcrumbs) {
          let breadcrumbs = JSON.parse(JSON.stringify(route.snapshot.data.breadcrumbs));
          breadcrumbs = breadcrumbs.filter((item: any) => item.label !== 'Special Interest');
          breadcrumbs.map((crumb: any) => {
            const labelParams = crumb.label.match(/[^{{]+(?=\}})/g);
            if (labelParams) {
              for (const labelParam of labelParams) {
                let routerParamID = this.params[labelParam.trim()];
                if (routerParamID) {
                  //if (window.location.href.indexOf('planyourvisit') >= 0 || window.location.href.indexOf('travelinfo') >= 0) {
                  if (this.menuArr[routerParamID]) {
                    routerParamID = this.menuArr[routerParamID];
                  }
                  //}
                  crumb.label = crumb.label.replace('{{' + labelParam + '}}', routerParamID);
                }
              }
            }
          });
          this.breadcrumbs = breadcrumbs;
          // localStorage.setItem('bread',JSON.stringify(this.breadcrumbs))
          // const url = new URL(window.location.href);
          // console.log(url);
          // localStorage.setItem('breadurl',url.pathname);
        } else {
          this.breadcrumbs = [];
        }
      });
  }
}
